import React from 'react'
import { Link } from 'react-router'

import Container from '../Container/Container'

const InvalidSignupError: React.FC = (): React.ReactElement => {
  return (
    <Container>
      <h1>Invalid sign up link</h1>
      <p>
        An email was sent that included a sign up link. That link must be used
        in order to create your account.
      </p>
      <p>
        If you already have an account,{' '}
        <Link to="/login" viewTransition>
          click here
        </Link>{' '}
        to log in.
      </p>
    </Container>
  )
}

export default InvalidSignupError
